(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ie-dropdown-script"] && !Shopify.designMode) return;
  try {
    const dropdownInteractiveSelector = [
    'a[href]',
    'button',
    'input',
    'select',
    'textarea',
    'summary',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]',
  ].join(', ');
  const dropdownStorageKeyPrefix = 'ie-dropdown-state';

  function getDropdownStorage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function getPersistedDropdownStorageKey(persistKey) {
    if (!persistKey) return null;
    return `${dropdownStorageKeyPrefix}:${window.location.pathname}:${persistKey}`;
  }

  function getPersistedDropdownState(persistKey) {
    const storage = getDropdownStorage();
    const storageKey = getPersistedDropdownStorageKey(persistKey);

    if (!storage || !storageKey) return null;

    try {
      const storedValue = storage.getItem(storageKey);

      if (storedValue !== 'true' && storedValue !== 'false') {
        return null;
      }

      return storedValue === 'true';
    } catch (error) {
      return null;
    }
  }

  function setPersistedDropdownState(dropdown, isOpen) {
    const storage = getDropdownStorage();
    const storageKey = getPersistedDropdownStorageKey(dropdown.persistKey);

    if (!storage || !storageKey) return;

    try {
      storage.setItem(storageKey, isOpen ? 'true' : 'false');
    } catch (error) {
      return;
    }
  }

  function getHashTargetDropdownElem() {
    const hash = window.location.hash;
    let hashTargetElem;

    if (!hash) return null;

    try {
      hashTargetElem = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (error) {
      hashTargetElem = document.getElementById(hash.slice(1));
    }

    let hashTargetDropdownElem = hashTargetElem;

    if (hashTargetDropdownElem && !hashTargetDropdownElem.classList.contains('js-dropdown')) {
      hashTargetDropdownElem = hashTargetDropdownElem.closest('.js-dropdown');
    }

    return hashTargetDropdownElem;
  }

  const hashTargetDropdownElem = getHashTargetDropdownElem();
  const state = {
    accordionDropdowns: {},
    openDropdowns: new Set(),
    dropdownsByElem: new WeakMap(),
    dropdownsByContentElem: new WeakMap(),
    hashTargetDropdownElem,
    hashTargetAccordionId: hashTargetDropdownElem && hashTargetDropdownElem.dataset.dropdownAccordionId,
    pendingHeightUpdates: new Set(),
    heightUpdateFrame: null,
  };
  let dropdownIdIndex = 0;
  const contentResizeObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver(function(entries) {
      for (const entry of entries) {
        scheduleOpenBranchHeightSync(state.dropdownsByContentElem.get(entry.target));
      }
    })
    : null;

  function getDropdownId(prefix) {
    dropdownIdIndex += 1;
    return `ie-dropdown-${prefix}-${dropdownIdIndex}`;
  }

  function getParentDropdownElem(elem) {
    const parentDropdownElem = elem.parentElement && elem.parentElement.closest('.js-dropdown');
    return parentDropdownElem && parentDropdownElem !== elem
      ? parentDropdownElem
      : null;
  }

  function ensureElementId(elem, prefix) {
    return elem.id || getDropdownId(prefix);
  }

  function isNativelyFocusable(elem) {
    if (!elem || elem.hasAttribute('disabled')) return false;
    if (elem.hasAttribute('tabindex')) return true;
    if (elem.isContentEditable) return true;

    const tagName = elem.tagName.toLowerCase();

    return tagName === 'a' && elem.hasAttribute('href')
      || tagName === 'button'
      || tagName === 'input'
      || tagName === 'select'
      || tagName === 'textarea'
      || tagName === 'summary'
      || tagName === 'iframe';
  }

  function ensureDropdownToggleFocusable(elem) {
    if (isNativelyFocusable(elem) || elem.hasAttribute('tabindex')) return;

    elem.setAttribute('tabindex', '0');
  }

  function initializeDropdownToggleAccessibility(elem) {
    if (!elem.hasAttribute('role') && !isNativelyFocusable(elem)) {
      elem.setAttribute('role', 'button');
    }

    ensureDropdownToggleFocusable(elem);
  }

  function restoreContentTabOrder(contentElem) {
    const focusableElems = contentElem.querySelectorAll(dropdownInteractiveSelector);

    for (const focusableElem of focusableElems) {
      if (!focusableElem.hasAttribute('data-ie-dropdown-tabindex')) continue;

      const previousTabIndex = focusableElem.getAttribute('data-ie-dropdown-tabindex');

      if (previousTabIndex === '') {
        focusableElem.removeAttribute('tabindex');
      } else {
        focusableElem.setAttribute('tabindex', previousTabIndex);
      }

      focusableElem.removeAttribute('data-ie-dropdown-tabindex');
    }
  }

  function disableContentTabbing(contentElem) {
    const focusableElems = contentElem.querySelectorAll(dropdownInteractiveSelector);

    for (const focusableElem of focusableElems) {
      if (!focusableElem.hasAttribute('data-ie-dropdown-tabindex')) {
        focusableElem.setAttribute(
          'data-ie-dropdown-tabindex',
          focusableElem.getAttribute('tabindex') || ''
        );
      }

      focusableElem.setAttribute('tabindex', '-1');
    }
  }

  function isToggleKey(event) {
    return event.key === 'Enter'
      || event.key === ' '
      || event.key === 'Spacebar'
      || event.keyCode === 13
      || event.keyCode === 32;
  }

  function hasTextSelection() {
    const selection = window.getSelection();
    return selection && selection.type === 'Range';
  }

  function getEventTargetElem(target) {
    if (!target) return null;
    return target.nodeType === Node.ELEMENT_NODE
      ? target
      : target.parentElement;
  }

  function shouldToggleDropdownFromClick(dropdown, event) {
    const targetElem = getEventTargetElem(event.target);

    if (!targetElem || hasTextSelection()) return false;

    const closestDropdownElem = targetElem.closest('.js-dropdown');

    if (closestDropdownElem && closestDropdownElem !== dropdown.elem) {
      return false;
    }

    const interactiveElem = targetElem.closest(dropdownInteractiveSelector);

    return !interactiveElem
      || interactiveElem === dropdown.elem
      || interactiveElem === dropdown.clickableElem;
  }

  function applyExpandedAriaState(dropdown) {
    dropdown.clickableElem.setAttribute('aria-expanded', 'true');
    dropdown.contentWrapElem.setAttribute('aria-hidden', 'false');
  }

  function applyCollapsedAriaState(dropdown) {
    dropdown.clickableElem.setAttribute('aria-expanded', 'false');
    dropdown.contentWrapElem.setAttribute('aria-hidden', 'true');
  }

  function dropdownsShareBranch(elem, candidateElem) {
    return elem.contains(candidateElem)
      || candidateElem.contains(elem);
  }

  function isDropdownOpen(dropdown) {
    return state.openDropdowns.has(dropdown);
  }

  function toggleDropdown(dropdown) {
    if (isDropdownOpen(dropdown)) {
      closeDropdown(dropdown);
    } else {
      openDropdown(dropdown);
    }
  }

  function closeAccordionPeers(dropdown) {
    const accordionGroup = dropdown.accordionId && state.accordionDropdowns[dropdown.accordionId];

    if (!accordionGroup) return;

    for (const accordionDropdown of accordionGroup) {
      if (accordionDropdown === dropdown) continue;
      if (dropdownsShareBranch(dropdown.elem, accordionDropdown.elem)) continue;
      if (!isDropdownOpen(accordionDropdown)) continue;
      closeDropdown(accordionDropdown);
    }
  }

  function getInitialDropdownOpenState(dropdown) {
    const defaultExpanded = dropdown.elem.classList.contains('js-dropdown-expanded');
    const persistedState = getPersistedDropdownState(dropdown.persistKey);
    const includesHashTarget = state.hashTargetDropdownElem
      && (state.hashTargetDropdownElem === dropdown.elem || dropdown.elem.contains(state.hashTargetDropdownElem));
    const clearDefaultExpanded = state.hashTargetDropdownElem
      && state.hashTargetAccordionId
      && dropdown.elem !== state.hashTargetDropdownElem
      && dropdown.elem.dataset.dropdownAccordionId === state.hashTargetAccordionId
      && !dropdownsShareBranch(dropdown.elem, state.hashTargetDropdownElem);

    return {
      clearDefaultExpanded,
      shouldOpen: includesHashTarget
        || (!clearDefaultExpanded && defaultExpanded)
        || (!clearDefaultExpanded && persistedState === true),
    };
  }

  function applyOpenDropdownState(dropdown) {
    dropdown.elem.classList.add('js-dropdown-expanded');
    dropdown.contentWrapElem.style.height = `${dropdown.contentElem.scrollHeight}px`;
    state.openDropdowns.add(dropdown);
    setPersistedDropdownState(dropdown, true);

    if (contentResizeObserver) {
      contentResizeObserver.observe(dropdown.contentElem);
    }

    restoreContentTabOrder(dropdown.contentElem);
    applyExpandedAriaState(dropdown);
    scheduleOpenBranchHeightSync(dropdown);
  }

  function applyClosedDropdownState(dropdown) {
    dropdown.elem.classList.remove('js-dropdown-expanded');
    dropdown.contentWrapElem.style.height = null;
    setPersistedDropdownState(dropdown, false);

    if (contentResizeObserver) {
      contentResizeObserver.unobserve(dropdown.contentElem);
    }

    disableContentTabbing(dropdown.contentElem);
    applyCollapsedAriaState(dropdown);
    state.openDropdowns.delete(dropdown);
    scheduleOpenBranchHeightSync(dropdown.parentDropdown || dropdown);
  }

  function openDropdown(dropdown) {
    if (isDropdownOpen(dropdown)) return;

    closeAccordionPeers(dropdown);
    applyOpenDropdownState(dropdown);
  }

  function closeDropdown(dropdown) {
    if (!isDropdownOpen(dropdown)) return;

    applyClosedDropdownState(dropdown);
  }

  function attachDropdownEventHandlers(dropdown) {
    dropdown.clickableElem.addEventListener('click', function(event) {
      if (!shouldToggleDropdownFromClick(dropdown, event)) return;

      toggleDropdown(dropdown);
    });

    dropdown.clickableElem.addEventListener('keydown', function(event) {
      if (event.target !== dropdown.clickableElem) return;
      if (!isToggleKey(event)) return;

      event.preventDefault();
      toggleDropdown(dropdown);
    });
  }

  function registerDropdownWithAccordion(dropdown) {
    if (!dropdown.accordionId) return;

    if (!state.accordionDropdowns[dropdown.accordionId]) {
      state.accordionDropdowns[dropdown.accordionId] = [];
    }

    state.accordionDropdowns[dropdown.accordionId].push(dropdown);
  }

  function unregisterDropdown(dropdown) {
    if (!dropdown) return;

    if (contentResizeObserver) {
      contentResizeObserver.unobserve(dropdown.contentElem);
    }

    state.openDropdowns.delete(dropdown);
    state.pendingHeightUpdates.delete(dropdown);

    if (!dropdown.accordionId || !state.accordionDropdowns[dropdown.accordionId]) return;

    state.accordionDropdowns[dropdown.accordionId] = state.accordionDropdowns[dropdown.accordionId].filter(
      function(accordionDropdown) {
        return accordionDropdown !== dropdown;
      }
    );

    if (state.accordionDropdowns[dropdown.accordionId].length === 0) {
      delete state.accordionDropdowns[dropdown.accordionId];
    }
  }

  function teardownDropdowns(root) {
    const scope = root || document;
    const dropdownElems = [];

    if (scope.matches && scope.matches('.js-dropdown')) {
      dropdownElems.push(scope);
    }

    dropdownElems.push(...scope.querySelectorAll('.js-dropdown'));

    for (const dropdownElem of dropdownElems) {
      unregisterDropdown(state.dropdownsByElem.get(dropdownElem));
      delete dropdownElem.dataset.ieDropdownInit;
    }
  }

  function scheduleOpenBranchHeightSync(dropdown) {
    if (!dropdown) return;

    state.pendingHeightUpdates.add(dropdown);

    if (state.heightUpdateFrame) return;

    state.heightUpdateFrame = window.requestAnimationFrame(function() {
      const dropdownsToUpdate = new Set();

      state.heightUpdateFrame = null;

      for (const pendingDropdown of state.pendingHeightUpdates) {
        let currentDropdown = pendingDropdown;

        while (currentDropdown) {
          if (isDropdownOpen(currentDropdown)) {
            dropdownsToUpdate.add(currentDropdown);
          }

          currentDropdown = currentDropdown.parentDropdown;
        }
      }

      state.pendingHeightUpdates.clear();

      for (const dropdownToUpdate of dropdownsToUpdate) {
        dropdownToUpdate.contentWrapElem.style.height = `${dropdownToUpdate.contentElem.scrollHeight}px`;
      }
    });
  }

  function getDropdownElements(elem) {
    const contentWrapElem = elem.querySelector('.js-dropdown-content-wrap');
    const contentElem = contentWrapElem && contentWrapElem.querySelector('.js-dropdown-content');

    if (!contentWrapElem || !contentElem) return null;

    const clickableElem = elem.classList.contains('js-dropdown-clickable')
      ? elem
      : elem.querySelector('.js-dropdown-clickable')
      || elem.querySelector('.js-dropdown-label')
      || elem;

    return {
      elem,
      clickableElem,
      contentElem,
      contentWrapElem,
      labelElem: elem.querySelector('.js-dropdown-label') || clickableElem,
      persistKey: elem.dataset.dropdownPersistKey || null,
      parentDropdownElem: getParentDropdownElem(elem),
    };
  }

  function initializeDropdownAccessibility(parts) {
    const contentWrapId = ensureElementId(parts.contentWrapElem, 'content');
    const labelId = parts.labelElem && ensureElementId(parts.labelElem, 'label');

    parts.elem.dataset.ieDropdownInit = 'true';
    parts.contentWrapElem.id = contentWrapId;

    if (parts.labelElem && !parts.labelElem.id) {
      parts.labelElem.id = labelId;
    }

    if (parts.clickableElem !== parts.elem) {
      parts.elem.removeAttribute('role');
      parts.elem.removeAttribute('aria-controls');
      parts.elem.removeAttribute('aria-expanded');
      parts.elem.removeAttribute('aria-labelledby');

      if (parts.elem.getAttribute('tabindex') === '0') {
        parts.elem.removeAttribute('tabindex');
      }
    }

    initializeDropdownToggleAccessibility(parts.clickableElem);
    parts.clickableElem.setAttribute('aria-controls', contentWrapId);

    if (parts.labelElem && parts.labelElem.id) {
      parts.clickableElem.setAttribute('aria-labelledby', parts.labelElem.id);
      parts.contentWrapElem.setAttribute('aria-labelledby', parts.labelElem.id);
    }

    parts.contentWrapElem.setAttribute('role', 'region');
  }

  function createDropdown(parts) {
    return {
      elem: parts.elem,
      accordionId: parts.elem.dataset.dropdownAccordionId,
      clickableElem: parts.clickableElem,
      contentElem: parts.contentElem,
      contentWrapElem: parts.contentWrapElem,
      persistKey: parts.persistKey,
      parentDropdown: null,
    };
  }

  function registerDropdownInstance(dropdown, parts) {
    state.dropdownsByElem.set(dropdown.elem, dropdown);
    state.dropdownsByContentElem.set(dropdown.contentElem, dropdown);
    dropdown.parentDropdown = parts.parentDropdownElem
      ? (state.dropdownsByElem.get(parts.parentDropdownElem) || null)
      : null;
  }

  function applyInitialDropdownState(dropdown) {
    const initialState = getInitialDropdownOpenState(dropdown);

    disableContentTabbing(dropdown.contentElem);
    applyCollapsedAriaState(dropdown);

    if (!initialState.shouldOpen) {
      dropdown.elem.classList.remove('js-dropdown-expanded');
    }

    if (initialState.shouldOpen) {
      openDropdown(dropdown);
    }
  }

  function initDropdown(elem) {
    if (elem.dataset.ieDropdownInit === 'true') return;

    const parts = getDropdownElements(elem);

    if (!parts) return;

    initializeDropdownAccessibility(parts);

    const dropdown = createDropdown(parts);

    registerDropdownInstance(dropdown, parts);
    applyInitialDropdownState(dropdown);

    registerDropdownWithAccordion(dropdown);
    attachDropdownEventHandlers(dropdown);
  }

  function initDropdowns(root) {
    const scope = root || document;

    if (scope.matches && scope.matches('.js-dropdown')) {
      initDropdown(scope);
    }

    const dropdownElems = scope.querySelectorAll('.js-dropdown');

    for (const dropdownElem of dropdownElems) {
      initDropdown(dropdownElem);
    }
  }

  function updateOpenHeights() {
    for (const dropdown of state.openDropdowns) {
      scheduleOpenBranchHeightSync(dropdown);
    }
  }

  window.addEventListener('resize', updateOpenHeights);

  document.addEventListener('shopify:section:load', function(event) {
    initDropdowns(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    teardownDropdowns(event.target || document);
  });

  initDropdowns(document);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slideshow"] && !Shopify.designMode) return;
  try {
    ;(function () {
    const slideshows = document.querySelectorAll('.ie-slideshow');

    slideshows.forEach(function(slideshow) {
      const duration = parseInt(slideshow.getAttribute('data-duration'));
      const items = slideshow.querySelectorAll('.ie-slideshow_item');
      if (items.length <= 1) return;

      let currentIndex = 0;
      items[0].classList.add('active');

      function advance() {
        items[currentIndex].classList.remove('active');
        currentIndex = (currentIndex + 1) % items.length;
        items[currentIndex].classList.add('active');
      }

      // First transition happens sooner to account for page load time
      setTimeout(function() {
        advance();
        setInterval(advance, duration);
      }, duration / 2);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wistia-button"] && !Shopify.designMode) return;
  try {
    // <script src="https://fast.wistia.com/assets/external/E-v1.js" async></script>
  var wistiaExternalScript = document.createElement('script');
  wistiaExternalScript.src = 'https://fast.wistia.com/assets/external/E-v1.js';
  wistiaExternalScript.async = true;
  document.head.appendChild(wistiaExternalScript);
  } catch(e) { console.error(e); }
})();

})();
